<template>
    <template v-for="(option, index) in options" :key="index">
        <template v-if="option.region">
            <template v-for="region in option.region" :key="region">
                <button @click="nextStep" :id="getRegion(region).id" :class="['btn btn--option', {'selected': checkSelected(getRegion(region).id)}]">
                    {{ getRegion(region).name }}
                </button>
            </template>
        </template>

        <template v-else>
            <button :class="['btn btn--option', {'selected': checkSelected(option.uniqueId)}]" 
                :id="option.uniqueId" 
                @click="nextStep" 
                v-html="formatValueWithUnit(option.quantity.value, option.quantity.unit)"
            >
            </button>
        </template>
    </template>
</template>

<script>
export default {
    name: 'NumberInput',
    props: ['options', 'regions', 'nextStep'],
    inject: ['formatValueWithUnit'],
    computed: {
        updatingOption() {
            return this.$store.getters['game/getIsUpadtingOption'];
        },
        savedOptions() {
            return this.$store.getters['game/getSavedOptions'];
        }
    },
    methods: {
        getRegion(id) {
            const region = this.regions.filter(reg => reg.node.id == id);

            return region[0].node;
        },
        checkSelected(id) {
            const savedOption = this.savedOptions.filter(option => option.data.uniqueId == id);

            if (this.updatingOption && savedOption.length) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
